module.exports = __webpack_public_path__ + "img/beijing.f86b4fac.png";